import React from 'react';

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h1>Xatolik yuz berdi</h1>
          <p>Iltimos, sahifani yangilang.</p>
          <button onClick={() => window.location.reload()}>Yangilash</button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
